import React from 'react';
import { hero } from '../../mock';
import { ArrowDown } from 'lucide-react';

const Hero = () => {
  return (
    <section id="top" className="relative w-full h-[100svh] min-h-[640px] overflow-hidden bg-navy">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={hero.image}
          alt="Luxury sunrise over sea"
          className="w-full h-full object-cover kenburns"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/55" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col">
        <div className="flex-1 flex items-center">
          <div className="max-w-[1400px] mx-auto w-full px-6 md:px-10">
            <div className="max-w-3xl">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold" />
                <span className="chapter-badge text-white/90 uppercase">{hero.eyebrow}</span>
              </div>
              <h1 className="font-serif-display text-white text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.05] font-medium">
                {hero.headline}
              </h1>
              <p className="mt-8 text-white/90 font-serif-editorial text-xl md:text-2xl leading-relaxed max-w-2xl">
                {hero.sub}
              </p>

              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <a href="#discover" className="btn-gold inline-flex items-center justify-center">
                  {hero.primaryCta}
                </a>
                <a
                  href="/activate"
                  className="inline-flex items-center justify-center px-7 py-4 border border-white/70 text-white text-[0.82rem] uppercase tracking-[0.1em] hover:bg-white/10 transition-colors duration-300"
                >
                  {hero.secondaryCta}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pb-10 flex flex-col items-center gap-2 text-white/80">
          <span className="chapter-badge uppercase">Your Journey Begins Here</span>
          <ArrowDown size={16} className="animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
